import api from './Base';
import { showError } from '../utils/showAlert';
import BackupSummary from '../types/backup/BackupSummary';
import BackupHistoryItem from '../types/backup/BackupHistoryItem';
import BackupAlert from '../types/backup/BackupAlert';

const get = async <T>(url: string, label: string): Promise<T[]> => {
    let result: T[] = [];
    await api.get<T[]>(url)
        .then((response) => { result = response.data; })
        .catch((error: any) => {
            console.error(`Failed to retrieve ${label}.`, error);
            showError(`Failed to retrieve ${label}`, error.message || error.toString());
        });
    return result;
};

const BackupApi = {
    // Every database with its current backup chain; the worst RPO covers the
    // last `days` days.
    getSummary: (days: number): Promise<BackupSummary[]> =>
        get<BackupSummary>(`backup/summary?days=${days}`, 'backup summary'),

    // Backups of one database over the last `days` days, newest first,
    // including those taken on other replicas of an availability group.
    getHistory: (id: number, database: string, days: number): Promise<BackupHistoryItem[]> =>
        get<BackupHistoryItem>(
            `backup/history?id=${id}&database=${encodeURIComponent(database)}&days=${days}`,
            'backup history'),

    getAlerts: (id: number, database: string, days: number): Promise<BackupAlert[]> =>
        get<BackupAlert>(`backup/alerts?id=${id}&database=${encodeURIComponent(database)}&days=${days}`, 'backup alerts'),

    // Names of the databases with backup monitoring, e.g. to scope alert rules.
    getDatabaseNames: async (): Promise<string[]> =>
        (await get<{ database: string }>('backup/database', 'backup databases')).map(row => row.database),
};

export default BackupApi;
